import { render, staticRenderFns } from "./DiscussBottomBar.vue?vue&type=template&id=35ad5d48&"
import script from "./DiscussBottomBar.vue?vue&type=script&lang=js&"
export * from "./DiscussBottomBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports